"use client";

import { useQueries } from "@tanstack/react-query";
import { browserCmw } from "@/lib/ky/browser";
import { PUBLIC_PRACTITIONERS_QUERY_KEY } from "@/hooks/use-public-practitioners";
import { useSavedPractitioners } from "./use-saved-practitioners";

/**
 * The `/saved` page's read: one `GET /practitioners/:username` per saved practitioner, fired in
 * parallel.
 *
 * A saved practitioner can go stale — they may have been unlisted since — so a `404` there drops
 * that card rather than failing the page; `isPending` is true only while every query is still on
 * its first fetch.
 */
export const useSavedPractitionersQuery = () => {
  const { ids } = useSavedPractitioners();

  const results = useQueries({
    queries: ids.map((username) => ({
      queryKey: [...PUBLIC_PRACTITIONERS_QUERY_KEY, username],
      queryFn: () => browserCmw.practitionersPublic.byUsername(username),
      retry: false,
    })),
  });

  return {
    practitioners: results.map((result) => result.data).filter((data) => data !== undefined),
    isPending: ids.length > 0 && results.some((result) => result.isPending),
  };
};
